import { render, staticRenderFns } from "./LayerIcon.vue?vue&type=template&id=d60ccf9a"
import script from "./LayerIcon.vue?vue&type=script&lang=js"
export * from "./LayerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports